
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        additionalService: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        isPaidPrice: {
            type: Boolean,
            default: false,
        },
        city: {
            type: String,
            default: null,
        },
    },
    setup() {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        return {
            formatAmount,
        }
    },
})
